/* Version 2026-10-09 3d588fd */
/* EMC search hook: the rewriting and the field-scoped query on a standard
   Shopify search form, without the popup.

   For a shop that keeps its own search bar (4Phones: the predictive search
   dropdown of its own theme). When the form is sent, the typed term is rewritten by
   phones-search-terms.js (synonyms, singular, model splitting, completion) and
   the field-scoped query goes to /search as q — the results page then shows
   exactly what the shopper meant, with Shopify's typo tolerance and
   relaxation switched off by the syntax. With the dropdown option set, the
   theme's predictive-search dropdown runs on the same query (see below).

   Load after phones-search-words.js, phones-search-lang-*.js, phones-search-rules.js
   and phones-search-terms.js (all deferred, in that order). EMC's own theme
   loads this file on the search page only, for a bare /search?q= link; its
   popup builds the same query itself.

   Options, set before this file runs:
     window.phonesSearchPipeTags = true   tags are written name|value (4Phones):
                                       every tag clause gets a star, since
                                       Shopify's exact tag index does not split
                                       on the bar and the prefix index does
                                       (measured 4-9)
     window.phonesSearchGroupTag = 'accessory'  optional: a group tag every result
                                       must carry, as the popup's tabs do
     window.phonesSearchSuggest = true | 'section'  the shop's predictive-search
                                       dropdown runs on our query; a string
                                       names the section that renders it
                                       (default predictive-search)
     window.phonesSearchSoftNote = '…'     the line above Shopify's loose
                                       results when nothing exact was found,
                                       for a theme that does not render it
                                       itself

   The theme renders that heading itself, hidden, in the dropdown section
   and on the search page: an element with data-phones-soft-note and hidden
   ("No exact match for …" and the count, from its translations), and
   data-phones-soft-hide on the normal result count. The hook only swaps the
   two. */

window.phonesSearchVersion = "2026-10-09 3d588fd";
(function () {
  const FIELDS = ['title', 'product_type', 'tag', 'vendor', 'variants.sku'];
  const PIPE = !!window.phonesSearchPipeTags;
  const FIELDS_PARAM = 'title,product_type,variants.title,variants.sku,vendor,tag';
  const esc = function (s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  };

  /* The typed term as word groups: per position the forms the rewriting
     allows (a synonym next to the typed word), from phones-search-terms.js */
  /* Strip characters that would break Shopify's field-scoped search syntax
     (colons, quotes, asterisks, slashes, brackets, etc.) or that are never
     meaningful in a product search.  Keep: a-z, 0-9, spaces, hyphens,
     periods and accented Latin characters (à-ÿ, Ā-ɏ). */
  function sanitize(s) {
    return s.replace(/[^a-z0-9\s.-À-ɏ]/g, '').replace(/\s+/g, ' ').trim();
  }

  function groupsOf(q) {
    const text = sanitize(String(q || '').toLowerCase().replace(/\s+/g, ' ').trim());
    if (!text) return [];
    if (window.phonesSearchTerms) {
      const r = window.phonesSearchTerms.rewrite(text);
      if (r.alternatives) return r.alternatives;
      return r.words.map(function (w) { return [w]; });
    }
    return text.split(/\s+/).filter(Boolean).map(function (w) { return [w]; });
  }

  /* The same rules as the popup's scopedQuery (phones-search-popup.js): every
     word required, alternatives per position, a star behind a last word of
     enough letters, a stray one- or two-letter tail dropped unless the model
     list knows it.

     A lone letter in the middle of a term stays (2-10). It used to be dropped
     anywhere, "because Shopify does not index one", and that made "iphone x
     display" the same search as "iphone display". Asked in quotes and per
     field Shopify does find it: title:"x" 114 products, "tab" with "a" 42
     against 292 for "tab" alone (measured on EMC, 2-10). On 4Phones 65 of
     1,416 models lost a word this way: every Galaxy Tab A, Z Fold and Z
     Flip, Huawei P Smart and iPhone X. As the last word it is dropped by
     the stray rule, where it may be somebody typing, but not after a model
     word (6-10, from the 4Phones session): in "iphone x", "moto e" and
     "samsung s" the word before says the letter is a model, and dropping it
     sent "iphone x" out as "iphone", a thousand products.

     A lone letter is asked on the title and the tag only (6-10): it is a
     model name, never a type, vendor or article number. Not on the tag
     alone, as 4Phones proposed: measured on EMC that cost real products,
     because the letter stands in the title where the model tag is missing
     or glued ("Oppo Reno8 T 4G" 10 → 0, "Reno4 Z 5G" 2 → 0, the P40 Lite E
     battery). The price of the title is the hyphen, where Shopify cuts a
     word: title:"x" also finds the "Armor-X" cases, title:"s" the "S-View"
     wallets. "iphone x" 1000 → 103, "samsung s" 1000 → 19, "galaxy tab a"
     280 → 42 (owc-dev). */
  /* Is the word before the last one a model word (iphone, moto, samsung)? */
  function afterModelWord(all) {
    const before = all.length > 1 ? all[all.length - 2] : [];
    return !!window.phonesSearchTerms && before.some(function (form) {
      return window.phonesSearchTerms.isModelWord(String(form));
    });
  }

  /* The forms of a position without the number-glued form the rewriting
     adds behind a short word (8t beside the t of "reno 8 t"): that form is
     the same word, so the position still counts as one short word. */
  /* The plural forms the rewriting puts beside a singular (pluralsOf in
     phones-search-terms.js) */
  function isPluralOf(form, word) {
    return form === word + 's' || form === word + 'es' ||
      (/[^aeiou]y$/.test(word) && form === word.slice(0, -1) + 'ies');
  }

  function ownForms(forms) {
    return forms.filter(function (form, k) {
      return k === 0 || !/^[0-9]+[a-z]{1,2}$/.test(String(form));
    });
  }

  function scopedQuery(all, groupTag) {
    const last = all[all.length - 1];
    const stray =
      all.length > 1 &&
      ownForms(last).length === 1 &&
      /^[a-z]{1,2}$/.test(String(last[0])) &&
      !(window.phonesSearchTerms && window.phonesSearchTerms.isModelWord(last[0])) &&
      /* a brand is no word being typed: "iphone 14 jk" (7-10) */
      !(window.phonesSearchTerms && window.phonesSearchTerms.isVendorWord && window.phonesSearchTerms.isVendorWord(last[0])) &&
      !(/^[a-z]$/.test(String(last[0])) && afterModelWord(all));
    const groups = stray ? all.slice(0, -1) : all;
    const parts = groups.map(function (forms, i) {
      const clauses = [];
      /* The glued model form the rewriting adds beside a word (fold5 beside
         fold, and beside the 5) is that word again, not a second way of
         saying it: a position that carries only that still counts as one
         word, or "pixel 8" would lose the star that finds the 8a. Digits in
         front count too (3ds beside the ds, 2-10). */
      const first = String(forms[0]).replace(/"/g, '');
      const own = forms.filter(function (form, k) {
        if (k === 0) return true;
        const w = String(form);
        /* Its plural, added by the rewriting (7-10), is that word again too:
           "display" kept its star beside "displays". */
        if (isPluralOf(w, first)) return false;
        const glued = /^([a-z]+[0-9]|[0-9]+[a-z])/.test(w) && w.indexOf(' ') < 0;
        return !(glued && (w.indexOf(first) === 0 || w.slice(-first.length) === first));
      });
      /* A half-typed last word is also asked as the catalogue words it may
         become: Shopify does not widen the star (startsOf in
         phones-search-terms.js, 6-10). They take the same path as the typed
         word, star and all, which on a whole word costs nothing. */
      const extra =
        i === groups.length - 1 && own.length === 1 && window.phonesSearchTerms && window.phonesSearchTerms.startsOf
          ? window.phonesSearchTerms.startsOf(first)
          : [];
      const asked = forms.concat(extra);
      for (let k = 0; k < asked.length; k += 1) {
        const word = String(asked[k]).replace(/"/g, '');
        const least = groups.length === 1 ? 2 : 3;
        /* Not on a code, letters and digits together (rxwc24, 22101316c): a
           typed code is complete, and the star widened rxwc24 to rxwc23 and
           rxwc25 as well — 14 products for 1 (measured 10-9). */
        const code = /\d/.test(word) && /[a-z]/.test(word);
        const open =
          i === groups.length - 1 &&
          own.length === 1 &&
          !code &&
          (new RegExp('^[a-z][a-z0-9]{' + (least - 1) + ',}$').test(word) ||
            (groups.length > 1 && /^[0-9]$/.test(word)));
        /* a lone letter is a model name: title and tag only (see above) */
        const letter = /^[a-z]$/.test(word);
        /* A model number with an s (a70s, 14s, g60s) is not asked in the
           title or type: Shopify stems it there to the model without the s.
           title:"a70s" and title:"a70" both gave the 28 A70 products, so
           "galaxy a70s display" listed A70 screens; tag:"a70s" gave the one
           A70s board (measured 7-10). The tags and the SKU keep it. */
        const modelS = /^[a-z]*[0-9]+s$/.test(word);
        for (let f = 0; f < FIELDS.length; f += 1) {
          if (letter && FIELDS[f] !== 'tag' && FIELDS[f] !== 'title') continue;
          if (modelS && (FIELDS[f] === 'title' || FIELDS[f] === 'product_type')) continue;
          /* name|value tags: only a prefix reaches the value behind the bar.
             A short word then also reaches the NAME before the bar: "pro"
             matched product_type|… on every product, so "iphone 17 pro" gave
             the whole shop (measured on 4phones.eu, 7-9). Below four letters
             the tag is asked exactly, without the star: on plain tags that
             still finds them (tpu is a material tag on 1,675 EMC products;
             leaving the field out dropped it to 266, measured 7-9), on
             name|value tags it finds nothing and does no harm. */
          const short = PIPE && FIELDS[f] === 'tag' && word.length < 4;
          /* A star only on a plain word: a phrase with a space ("tempered
             glass", from a synonym) must stay quoted, or Shopify reads
             tag:tempered glass* as two things (seen in a preview, 7-9). */
          const star = !short && (open || (PIPE && FIELDS[f] === 'tag' && /^[a-z0-9]+$/.test(word)));
          clauses.push(FIELDS[f] + ':' + (star ? word + '*' : '"' + word + '"'));
        }
      }
      return '(' + clauses.join(' OR ') + ')';
    });
    if (groupTag) parts.push('(tag:' + (PIPE ? groupTag + '*' : '"' + groupTag + '"') + ')');
    return parts.join(' AND ');
  }

  function hidden(form, name, value) {
    let el = form.querySelector('input[type="hidden"][name="' + name + '"]');
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = name;
      form.appendChild(el);
    }
    el.value = value;
  }

  /* Every search form on the page, including the one the theme renders in
     the predictive-search dropdown; the typed term rides along as phonesq so the
     results page can show it instead of the query. */
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!/\/search\/?$/.test(form.getAttribute('action') || '')) return;
    /* A form that handles Enter itself (the EMC popup searches in place and
       cancels the submit) is not navigating: nothing to rewrite there, and
       writing into its field would leave the query on screen (found by the
       4phones session, 8-9). */
    if (e.defaultPrevented) return;
    const input = form.querySelector('input[name="q"]');
    if (!input) return;
    const typed = input.value.trim();
    const groups = groupsOf(typed);
    if (!groups.length) return;
    const query = scopedQuery(groups, window.phonesSearchGroupTag || '');
    if (window.console && !window.phonesSearchQuiet) console.log('[phones-zoek] "' + typed + '" → ' + query);
    /* The query travels as a hidden q; the visible field keeps the typed
       term, so it does not flash into a line of title:... OR tag:... before
       the page leaves. The browser serialises the form after this handler
       returns, so the field is nameless for exactly that moment and gets its
       name back a tick later — the form keeps working when the navigation
       does not happen after all (Escape, a cancelled submit). */
    input.removeAttribute('name');
    hidden(form, 'q', query);
    setTimeout(function () { input.setAttribute('name', 'q'); }, 0);
    hidden(form, 'phonesq', typed);
    hidden(form, 'type', 'product');
    hidden(form, 'options[prefix]', 'last');
    hidden(form, 'options[fields]', 'title,product_type,variants.title,variants.sku,vendor,tag');
    /* The tab chosen in the dropdown goes along to the page as a filter, so
       "View all" shows the list the shopper was looking at (asked 7-10). */
    const ps = Array.prototype.find.call(document.querySelectorAll('predictive-search'), function (el) {
      return el.contains(form) || form.contains(el) || (el.input && el.input.form === form);
    });
    const tab = ps && ps.querySelector('.predictive-search_tab.is--active');
    const type = tab && tab.dataset.filterType;
    if (type && type !== '*') hidden(form, 'filter.p.product_type', type);
    else {
      const stale = form.querySelector('input[type="hidden"][name="filter.p.product_type"]');
      if (stale) stale.remove();
    }
  });

  /* The dropdown, when the shop's theme has one (window.phonesSearchSuggest;
     4Phones). Taken over from the version 4Phones built on 4phones.eu (7-10):
     instead of swapping every fetch on the page, the predictive-search
     component's own getSearchResults is replaced, so only its requests
     change and its cache, abort and rendering stay the theme's.

     The results come through the Section Rendering API with our query. The
     section is named by the option when it is a string (the 4Phones test
     theme: phones-search-suggest) and is predictive-search otherwise (live:
     their predictive-search section renders search.results as well). It
     leaves __typed_term__ where the typed term goes.

     Nothing exact found: the dropdown then shows Shopify's own loose search
     for the typed term, under a line that says so ("No exact match. Search
     suggestions:"; no platform name in front of shoppers, asked 7-10).
     4Phones fell back silently, and the shopper saw
     ten products in the dropdown and an empty page after Enter (asked 7-10:
     the dropdown and the page must agree). The loose answer comes from the
     same /search the results page uses (see softPage below), not from the
     suggest endpoint, so both show the same products.

     A typed OEM code (window.FourPhOemSearch, 4Phones' own script) is looked
     up exactly first, as on 4phones.eu; the component then takes over with
     the code's products. */
  /* The heading itself belongs to the theme: rendered hidden, with the
     data-phones-soft-note attribute, in the theme's own words per language and
     in its own place, so the hook only switches it on, and switches off what
     it replaces (data-phones-soft-hide: the normal "N results for …", 7-10). An
     English line pinned in here showed on /nl/ as well. A theme without the
     element (4phones.eu until it is updated) gets this line put in, styled
     inline as it has no CSS for it. The hidden attribute would lose to a
     display rule of the theme, so what is hidden gets display:none. */
  const SOFT_NOTE = function () {
    return window.phonesSearchSoftNote || 'No exact match. Search suggestions:';
  };
  function showSoftNote(scope, anchor) {
    const own = scope.querySelector('[data-phones-soft-note]');
    if (own) {
      own.removeAttribute('hidden');
      scope.querySelectorAll('[data-phones-soft-hide]').forEach(function (el) { el.style.display = 'none'; });
      return;
    }
    const note = document.createElement('p');
    note.className = 'phones-search-soft-note'; 
    note.setAttribute('data-phones-soft-note', '');
    note.textContent = SOFT_NOTE();
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(note, anchor);
    else scope.insertBefore(note, scope.firstChild);
  }
  function patchDropdown(PS) {
    if (!PS || PS.prototype.__phonesPatched) return;
    PS.prototype.__phonesPatched = true;
    const SECTION = typeof window.phonesSearchSuggest === 'string' ? window.phonesSearchSuggest : 'predictive-search';
    const origGetSearchResults = PS.prototype.getSearchResults;
    const tabsFor = {};
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const sectionUrl = function (q, scoped) {
      return root + 'search?type=product&options%5Bprefix%5D=last' +
        (scoped ? '&options%5Bfields%5D=' + encodeURIComponent(FIELDS_PARAM) : '') +
        '&q=' + encodeURIComponent(q) + '&section_id=' + encodeURIComponent(SECTION);
    };
    const markupOf = function (html, typed, soft) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const section = doc.querySelector('#shopify-section-' + SECTION);
      if (!section) return null;
      if (soft) showSoftNote(section, section.querySelector('[data-predictive-search-count]'));
      return section.innerHTML.split('__typed_term__').join(esc(typed));
    };
    /* The tabs carry counts over the whole result; a filtered answer knows
       only its own type, so the unfiltered tabs are kept per term (and per
       exact or loose answer, whose types differ) and put back with the
       chosen one lit. */
    const TABS = /<div class="predictive-search_tabs"[\s\S]*?<\/div>/;
    const lightTabs = function (markup, key, productType) {
      const found = markup.match(TABS);
      if (!productType && found) tabsFor[key] = found[0];
      if (!productType || !tabsFor[key]) return markup;
      const lit = tabsFor[key]
        .replace(/aria-selected="true" class="predictive-search_tab is--active"/g, 'aria-selected="false" class="predictive-search_tab"')
        .replace(new RegExp('aria-selected="false" class="predictive-search_tab" data-filter-type="' + productType.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '"'),
          'aria-selected="true" class="predictive-search_tab is--active" data-filter-type="' + productType + '"');
      return found ? markup.replace(TABS, lit) : markup.replace(/(<ul[^>]*data-products-list)/, lit + '$1');
    };
    PS.prototype.getSearchResults = function (searchTerm, productType, queryOverride) {
      /* an OEM code's products: the component's own request, as on 4phones.eu */
      if (queryOverride) return origGetSearchResults.call(this, searchTerm, productType, queryOverride);
      const groups = groupsOf(searchTerm);
      if (!groups.length) return origGetSearchResults.call(this, searchTerm, productType);
      const queryKey = (searchTerm + '-' + (productType || '')).toLowerCase().replace(/\s+/g, '-');
      if (this.cachedResults[queryKey]) {
        this.renderSearchResults(this.cachedResults[queryKey]);
        return;
      }
      const oem = window.FourPhOemSearch;
      const exactLookup = oem && oem.isCode(searchTerm) ? oem.exactMatches(searchTerm) : null;
      const query = scopedQuery(groups, window.phonesSearchGroupTag || '');
      /* A chosen tab is Shopify's product-type filter, the same one the tab's
         count comes from and the results page applies. As a clause in q it
         matched per word: tab "Camera (6)" listed 24, Camera lens cover and
         Camera protector included (7-10). The filter keeps the field-scoped
         query (measured: iphone 13 cam 53, with the filter 6). */
      const typeFilter = productType && productType !== '*' ? '&filter.p.product_type=' + encodeURIComponent(productType) : '';
      if (window.console && !window.phonesSearchQuiet) console.log('[phones-zoek] dropdown "' + searchTerm + '" → ' + query + (typeFilter ? ' [' + productType + ']' : ''));
      const self = this;
      const signal = this.abortController ? this.abortController.signal : undefined;
      const get = function (url) {
        return fetch(url, { signal: signal }).then(function (res) {
          if (!res.ok) throw new Error(res.status);
          return res.text();
        });
      };
      get(sectionUrl(query, true) + typeFilter)
        .then(function (html) {
          const markup = markupOf(html, searchTerm, false);
          if (markup === null) { self.close(); return null; }
          if (markup.indexOf('data-products-wrap') >= 0) return lightTabs(markup, searchTerm, productType);
          /* Nothing exact: Shopify's loose search, said so, with the same
             filter; put into q the tab became three more loose words
             ("screens and displays", 7-10). */
          return get(sectionUrl(sanitize(searchTerm.toLowerCase()), false) + typeFilter).then(function (soft) {
            const loose = markupOf(soft, searchTerm, true);
            if (loose === null || loose.indexOf('data-products-wrap') < 0) return lightTabs(markup, searchTerm, productType);
            return lightTabs(loose, searchTerm + '\n~', productType);
          });
        })
        .then(function (markup) {
          if (markup == null) return;
          const finish = function () {
            (self.allPredictiveSearchInstances || [self]).forEach(function (inst) { inst.cachedResults[queryKey] = markup; });
            self.renderSearchResults(markup, searchTerm);
          };
          if (exactLookup) {
            return exactLookup.then(function (match) {
              if (match && self.searchTerm === searchTerm) self.getSearchResults(searchTerm, productType, match);
              else finish();
            });
          }
          finish();
        })
        .catch(function (error) {
          if (error && (error.code === 20 || error.name === 'AbortError')) return;
          self.close();
          throw error;
        });
    };
  }
  if (window.phonesSearchSuggest && window.customElements) {
    const PS = customElements.get('predictive-search');
    if (PS) patchDropdown(PS);
    else if (customElements.whenDefined) customElements.whenDefined('predictive-search').then(function () { patchDropdown(customElements.get('predictive-search')); });
    /* After a tab click the theme replaces the panel; focus falls to the
       page and the theme's open() — where it sizes the panel — is skipped,
       so the panel fell back to the search bar's width (seen 7-9). Every new
       panel is sized again. */
    const watched = new WeakSet();
    const watchPanels = function () {
      document.querySelectorAll('predictive-search').forEach(function (ps) {
        const box = ps.predictiveSearchResults || ps.querySelector('[data-predictive-search-results]');
        if (!box || watched.has(box) || typeof MutationObserver !== 'function') return;
        watched.add(box);
        new MutationObserver(function () {
          if (typeof ps.positionResults !== 'function') return;
          ps._deskApplied = false;
          ps.positionResults();
        }).observe(box, { childList: true });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchPanels);
    else watchPanels();
    /* A tab click asks the component for that type, through the override. */
    document.addEventListener('click', function (e) {
      const t = e.target.closest ? e.target.closest('.predictive-search_tab') : null;
      if (!t) return;
      const ps = t.closest('predictive-search');
      const input = ps && ps.querySelector('input[name="q"]');
      if (!ps || typeof ps.getSearchResults !== 'function' || !input) return;
      /* The new answer replaces the panel's markup, the clicked tab with it.
         That tab had focus, so focus fell to the page, and the theme's
         onFocusOut (focus outside the search: close) shut the dropdown on
         every tab click (4Phones, 9-10). Focus goes to the panel itself
         first: it stays, only its contents are replaced. Not to the input,
         which would bring a phone's keyboard back up over the results. */
      const box = ps.predictiveSearchResults;
      if (box && box.focus) {
        box.tabIndex = -1;
        box.focus({ preventScroll: true });
      }
      const type = t.dataset.filterType;
      ps.getSearchResults(input.value.trim(), type === '*' ? '' : type);
    }, true);
  }

  /* The results page agrees with the dropdown (7-10): when the exact search
     found nothing, the page goes on to Shopify's loose search for the typed
     term, under the same line the dropdown shows. Only for a shop that uses
     this file as its search (the dropdown option is set); EMC's own search
     page fills from the app's index and never comes here. One extra load,
     and only for an empty result. */
  /* Shopify leaves phonessoft out of the links it renders (pagination, page 2),
     so the next page came back with a plain q, was rebuilt as an exact query,
     found nothing and went back to the loose page 1 (dev.4phones.eu, 8-10).
     The links of a loose page carry it again. */
  function softLinks() {
    document.querySelectorAll('a[href*="/search"][href*="page="]').forEach(function (a) {
      try {
        const u = new URL(a.getAttribute('href'), window.location.origin);
        if (u.searchParams.get('phonessoft') || /[:()"*]/.test(u.searchParams.get('q') || '')) return;
        u.searchParams.set('phonessoft', '1');
        a.setAttribute('href', u.pathname + u.search);
      } catch (e) { /* not a link we can read: leave it */ }
    });
  }

  function softPage() {
    if (!window.phonesSearchSuggest || !/\/search\/?$/.test(window.location.pathname)) return;
    const params = new URLSearchParams(window.location.search);
    const typed = params.get('phonesq');
    if (params.get('phonessoft')) {
      /* Put in by the hook, the line goes above the products, in their
         column: at the top of main it ran against the screen edge, outside
         the page's container (4Phones test theme, 7-10). #ProductGrid is
         theirs, the other two are Dawn's. */
      const show = function () {
        const spot = document.getElementById('ProductGrid') || document.getElementById('ProductGridContainer') ||
          document.querySelector('.template-search__header') ||
          document.getElementById('MainContent') || document.querySelector('main');
        if (spot) showSoftNote(spot, null);
        softLinks();
      };
      show();
      /* A filter click re-renders the grid, hidden line and all, without a
         page load. The results stay loose as long as q is the plain typed
         term (an exact query always holds a field: title:…). */
      const grid = document.getElementById('ProductGrid') || document.getElementById('ProductGridContainer');
      if (grid && typeof MutationObserver === 'function') {
        new MutationObserver(function () {
          const q = new URLSearchParams(window.location.search).get('q') || '';
          const note = document.querySelector('[data-phones-soft-note]');
          if (q.indexOf(':') < 0 && (!note || note.hidden)) show();
          else softLinks();
        }).observe(grid, { childList: true });
      }
      return;
    }
    if (!typed) return;
    const main = document.getElementById('MainContent') || document.querySelector('main') || document.body;
    const empty = /(^|\D)0\s+results?\b/i.test(document.title) || !main.querySelector('a[href*="/products/"]');
    if (!empty) return;
    const soft = new URLSearchParams();
    soft.set('q', typed);
    soft.set('type', 'product');
    soft.set('options[prefix]', 'last');
    soft.set('phonessoft', '1');
    if (params.get('filter.p.product_type')) soft.set('filter.p.product_type', params.get('filter.p.product_type'));
    window.location.replace(window.location.pathname + '?' + soft.toString());
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', softPage);
  else softPage();

  /* On the results page: the field and the heading show the typed term, not
     the query; the query stays in the URL. Themes word the heading in their
     own way ("1000 results found for "…"" on 4phones.eu, seen 5-9), so no
     class is assumed: every text node that carries the query gets the typed
     term in its place. */
  function showTyped() {
    const params = new URLSearchParams(window.location.search);
    const typed = params.get('phonesq');
    const query = params.get('q');
    if (!typed || !query) return;
    /* Not a hidden q: that one is the filter form's and must keep the
       scoped query. Given the typed term, a ticked filter searched every
       field loosely ("iphone 11 system": 12 results, with the brand filter
       of 1 product 292; 4Phones, 9-10). */
    document.querySelectorAll('input[name="q"]').forEach(function (el) { if (el.type !== 'hidden') el.value = typed; });
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    const hits = [];
    while (walker.nextNode()) if (walker.currentNode.nodeValue.indexOf(query) >= 0) hits.push(walker.currentNode);
    hits.forEach(function (node) { node.nodeValue = node.nodeValue.split(query).join(typed); });
    if (document.title.indexOf(query) >= 0) document.title = document.title.split(query).join(typed);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', showTyped);
  else showTyped();

  /* The filter form on the results page carries q (hidden) and its filters,
     not the typed term, the loose mark or the field list: a ticked filter
     lost them, so the next page showed the query in the box and a reload
     treated a loose page as exact. They go along when the form is read.
     On the formdata event and not as inputs in the form: the theme redraws
     the form after every filter, and added inputs would go with it. Only a
     form with a hidden q; the search box's own form starts a new search. */
  document.addEventListener('formdata', function (e) {
    const form = e.target;
    if (!form || !form.querySelector || !form.querySelector('input[type="hidden"][name="q"]')) return;
    if (!/\/search\/?$/.test(window.location.pathname)) return;
    const params = new URLSearchParams(window.location.search);
    ['phonesq', 'phonessoft', 'type', 'options[fields]'].forEach(function (key) {
      const value = params.get(key);
      if (value && !e.formData.has(key)) e.formData.append(key, value);
    });
  }, true);

  /* A bare /search?q=<word> — a typed address, an older link, a link from
     elsewhere in the theme — is sent on to the scoped query, so it lands on
     the same results the search box gives. One extra load, and only for such
     a link.

     The address bar keeps that scoped query. Showing the typed term instead
     was tried on 8-9 and taken out again: the server then answers the bare
     word on every reload and on every shared link, so the shopper sees the
     wide result first and the right one a moment later — through a second
     page load or through a section swap, either way visible. What was typed
     still reaches the box and the heading through phonesq, in showTyped above. */
  /* The search-page address for a typed term: the scoped query as q, the
     typed term as phonesq. Used by tidyUrl below and, since 16-9, by the device
     chooser on the search page, which fetches it and swaps the results in. */
  function searchUrlFor(typed, base) {
    const groups = groupsOf(typed);
    if (!groups.length) return null;
    const params = new URLSearchParams(base || '');
    params.set('q', scopedQuery(groups, window.phonesSearchGroupTag || ''));
    params.set('phonesq', typed);
    params.set('type', 'product');
    params.set('options[prefix]', 'last');
    params.set('options[fields]', 'title,product_type,variants.title,variants.sku,vendor,tag');
    return window.location.pathname + '?' + params.toString();
  }
  function tidyUrl() {
    if (!/\/search\/?$/.test(window.location.pathname)) return;
    const params = new URLSearchParams(window.location.search);
    const query = params.get('q');
    if (!query) return;
    /* phonessoft: the loose search the page went on to on purpose (softPage) */
    if (params.get('phonesq') || params.get('phonessoft') || /[:()"*]/.test(query)) return;
    /* A later page with a plain q is a loose page being paged (an exact
       page's links always carry a field), reached through a link that lost
       its phonessoft: it stays loose, with its note. */
    if (+params.get('page') > 1 && window.phonesSearchSuggest) {
      params.set('phonessoft', '1');
      window.history.replaceState(window.history.state, '', window.location.pathname + '?' + params.toString());
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', softPage);
      else softPage();
      return;
    }
    const target = searchUrlFor(query, window.location.search);
    if (target) window.location.replace(target);
  }
  tidyUrl();
  window.phonesSearchHook = {
    url: function (typed) { return searchUrlFor(typed, ''); },
    showTyped: showTyped,
    /* the query builder by name, so a test can ask what a term becomes
       without a form to submit (tests/search-hook.test.mjs) */
    groupsOf: groupsOf,
    scopedQuery: scopedQuery,
  };
})();
